import uploadButton from './index.vue'

const components={
  install(Vue){
    Vue.component('upload-button', uploadButton)
  }
}

if(typeof window !=='undefined' && window.Vue){
  install(window.Vue);
}
 
export default components;
